import { Component, h } from 'preact';
import pym from 'pym.js';
import Tock from 'tocktimer';

import Countdown from './countdown';
import Results from './results';
import TopNews from './top-news';

import getParameterByName from '../utils/get-parameter-by-name';
import getResults from '../utils/get-results';
import getTopNews from '../utils/get-top-news';

const shouldIncludeTopNews = (getParameterByName('top-news') === '1');
const raceIds = getParameterByName('ids');

let racesToInclude;

if (raceIds) {
  racesToInclude = getParameterByName('ids').split(',').map((id) => +id);
} else {
  racesToInclude = [553]; // only U.S. President
}

class EmbedContainer extends Component {
  constructor () {
    super();

    this.state = {
      races: [],
      posts: [],
      topNewsTimestamp: null,
      timeLeft: 0
    };

    this.child = new pym.Child();

    this.onTick = this.onTick.bind(this);
    this.onComplete = this.onComplete.bind(this);

    this.duration = 30 * 1000;

    this.timer = new Tock({
      countdown: true,
      interval: 1000,
      callback: this.onTick,
      complete: this.onComplete
    });
  }

  onTick () {
    const now = Math.ceil(this.timer.lap() / 1000);
    this.setState({
      timeLeft: now === 0 ? 'Updating!' : now
    });
  }

  onComplete () {
    this.fetchData();
  }

  fetchData () {
    const requests = [];

    if (shouldIncludeTopNews) {
      const whenGetTopNews = getTopNews().then((topNews) => {
        const posts = topNews.data.top_news;
        const topNewsTimestamp = topNews.timestamp;

        this.setState({ posts, topNewsTimestamp });
      });

      requests.push(whenGetTopNews);
    }

    const whenGetResults = getResults().then((races) => {
      const activeRaces = races.filter((race) => racesToInclude.indexOf(race.id) >= 0);

      this.setState({ races: activeRaces });
    });

    requests.push(whenGetResults);

    Promise.all(requests).then(() => {
      this.timer.start(this.duration);
    });
  }

  componentDidMount () {
    this.fetchData();
    this.child.sendHeight();
  }

  componentDidUpdate () {
    this.child.sendHeight();
  }

  render () {
    let topNewsElement = null;

    if (shouldIncludeTopNews) {
      topNewsElement = <TopNews topNewsTimestamp={this.state.topNewsTimestamp} posts={this.state.posts} />;
    }

    return (
      <div>
        <Countdown alignment='center' timeLeft={this.state.timeLeft} />
        <Results races={this.state.races} />
        {topNewsElement}
      </div>
    );
  }
}

export default EmbedContainer;



// WEBPACK FOOTER //
// ./components/embed-container.js